import { navigateAction } from 'fluxible-router';
import ApplicationStore from '../stores/ApplicationStore';
import getQuickstartUrl from '../util/getQuickstartUrl';

export default function navigateToQuickstart(context, payload, done) {
  const { quickstartId, platformId, versionId, articleId } = payload;
  const appStore = context.getStore(ApplicationStore);

  const url = getQuickstartUrl(
    { quickstartId, platformId, versionId, articleId },
    appStore.isFramedMode(),
    appStore.isSingleQuickstartMode()
  );

  return navigateAction(context, { url }, done);
}
